import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AttentionReportsDashboard } from '@/components/enterprise/AttentionReportsDashboard';
import EditorialMenu from '@/components/editorial/EditorialMenu';
import { 
  Monitor, Eye, DollarSign, Calendar, BarChart3, 
  TestTube, AlertTriangle, Database, Activity 
} from 'lucide-react';
import { cn } from '@/lib/utils';

const enterpriseNavLinks = [
  { path: '/enterprise', label: 'Dashboard', icon: Monitor },
  { path: '/enterprise/attention-reports', label: 'Attention Reports', icon: Eye },
  { path: '/enterprise/ad-economy', label: 'Annonseøkonomi', icon: DollarSign },
  { path: '/booking', label: 'Booking (BB)', icon: Calendar },
  { path: '/analytics', label: 'Analytikk & Innsikt', icon: BarChart3 },
  { path: '/ab-testing', label: 'A/B Testing', icon: TestTube },
  { path: '/alerts', label: 'Overvåkning & Varsler', icon: AlertTriangle },
  { path: '/backup', label: 'Sikkerhetskopi', icon: Database },
  { path: '/monitoring', label: 'Systemovervåkning', icon: Activity },
];

const EnterpriseNav: React.FC = () => {
  const location = useLocation();
  
  return (
    <nav className="bg-muted/30 border-b mb-6">
      <div className="container mx-auto px-6">
        <div className="flex items-center gap-1 overflow-x-auto py-2">
          {enterpriseNavLinks.map((link) => {
            const Icon = link.icon;
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={cn(
                  "flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors",
                  isActive 
                    ? "bg-primary text-primary-foreground" 
                    : "text-muted-foreground hover:text-foreground hover:bg-muted"
                )}
              >
                <Icon className="h-4 w-4" />
                {link.label}
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

const AttentionReportsPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      {/* Top bar with Editorial Menu */}
      <div className="border-b bg-background">
        <div className="container mx-auto px-6 py-3 flex justify-end">
          <EditorialMenu />
        </div>
      </div>
      
      <EnterpriseNav />
      <div className="container mx-auto py-6">
        <AttentionReportsDashboard />
      </div>
    </div>
  );
};

export default AttentionReportsPage;
